export const validateAndSubmit = {
    data() {
        disableOnSubmit: false
    },
    methods: {
        /**
         * General helper method for any forms in the site
         *
         * @param  {obj} event
         *
         * @return {void}
         */
        validateAndSubmit(scope, modalId = null, single = false) {
            this.disableOnSubmit = true;
            let _self = this;

            this.$validator.validateAll(scope).then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    let form = document.getElementById(scope);

                    if (this.isEdit && this.isEdit == 'true') {
                        this.put(scope, modalId, single);
                    } else {
                        this.post(scope, modalId, single);
                    }
                }

                if (!result) {
                    _self.disableOnSubmit = false;
                    // Scroll the the first "invalid-feedback" message (if there's one)
                    $('html, body').animate({scrollTop: $('.invalid-feedback').first().offset().top -100 }, 'slow');
                }
            });

        },

        post(scope, modalId, single) {
            var form = document.getElementById(scope);
            var formData = new FormData(form);
            this.error = false;

            // return formData;
            axios
                .post(this.url, formData, {
                    params: {
                    },
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                )
                .then(response => {
                    if (response.data.message && !single) {
                        if (response.data.success === true) {
                            this.$root.$refs.toastr.s(response.data.message);
                        } else {
                            this.$root.$refs.toastr.e(response.data.message);
                        }
                    }
                    if (modalId) {
                        $('#' + modalId).modal('hide');
                    }
                    this.disableOnSubmit = false;
                    if (response.data.url && !single) {
                        window.location = response.data.url;
                    }
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$root.$refs.toastr.e(this.showErrors(error));
                    } else {
                        this.$root.$refs.toastr.e("ERROR");

                        this.message = {
                            'type': 'alert-danger',
                            'message': error.response.data.message
                        }
                    }
                    this.disableOnSubmit = false;
                });
        },

        put(scope, modalId, single) {
            var form = document.getElementById(scope);
            var formData = new FormData(form);
            this.error = false;
            var data = this.form;
            delete data['hashid'];

            // return formData;
            axios
                .put(this.url, formData, {
                    params: data,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                )
                .then(response => {
                    if (response.data.message && !single) {
                        if (response.data.success === true) {
                            this.$root.$refs.toastr.s(response.data.message);
                        } else {
                            this.$root.$refs.toastr.e(response.data.message);
                        }
                    }
                    if (modalId) {
                        $('#' + modalId).modal('hide');
                    }
                    this.disableOnSubmit = false;
                    if (response.data.url && !single) {
                        window.location = response.data.url;
                    }
                })
                .catch(error => {
                    if (error.status == 422) {
                        this.$root.$refs.toastr.e(this.showErrors(error));
                    } else {
                        this.$root.$refs.toastr.e("ERROR");

                        this.message = {
                            'type': 'alert-danger',
                            'message': error.response.data.message
                        }
                        this.disableOnSubmit = false;
                    }
                });
        },

        showErrors(error) {
            var display = '';
            var errors = error.response.data.error.errors;
            var x;

            for (x in errors) {
                display += errors[x][0] + '\n';
            }

            return display;
        }
    }
}
